var map = {
	"./auth/i18n/lang.json": 93701,
	"./billing/i18n/lang.json": 20945,
	"./cam/i18n/lang.json": 1895,
	"./care-sheet/i18n/lang.json": 49423,
	"./certificate/i18n/lang.json": 80507,
	"./consultation/i18n/lang.json": 94255,
	"./dental-consultation/i18n/lang.json": 9174,
	"./exam/i18n/lang.json": 20540,
	"./example-module/i18n/lang.json": 10926,
	"./forms/i18n/lang.json": 57220,
	"./frontdesk/i18n/lang.json": 42876,
	"./general-payment/i18n/lang.json": 48686,
	"./generic-states/i18n/lang.json": 36139,
	"./hospitalization/i18n/lang.json": 79451,
	"./medical-care/i18n/lang.json": 2457,
	"./oximetry/i18n/lang.json": 8795,
	"./parameters/i18n/lang.json": 24856,
	"./patient/i18n/lang.json": 88008,
	"./payment/i18n/lang.json": 81210,
	"./prescription/i18n/lang.json": 4701,
	"./rehabilitation/i18n/lang.json": 51894,
	"./shared/i18n/lang.json": 12739,
	"./specifics/i18n/lang.json": 11243,
	"./stand-alone/i18n/lang.json": 31177,
	"./stock/i18n/lang.json": 12132,
	"./visit/i18n/lang.json": 87212,
	"./workflow/i18n/lang.json": 2614,
	"auth/i18n/lang.json": 93701,
	"billing/i18n/lang.json": 20945,
	"cam/i18n/lang.json": 1895,
	"care-sheet/i18n/lang.json": 49423,
	"certificate/i18n/lang.json": 80507,
	"consultation/i18n/lang.json": 94255,
	"dental-consultation/i18n/lang.json": 9174,
	"exam/i18n/lang.json": 20540,
	"example-module/i18n/lang.json": 10926,
	"forms/i18n/lang.json": 57220,
	"frontdesk/i18n/lang.json": 42876,
	"general-payment/i18n/lang.json": 48686,
	"generic-states/i18n/lang.json": 36139,
	"hospitalization/i18n/lang.json": 79451,
	"medical-care/i18n/lang.json": 2457,
	"oximetry/i18n/lang.json": 8795,
	"parameters/i18n/lang.json": 24856,
	"patient/i18n/lang.json": 88008,
	"payment/i18n/lang.json": 81210,
	"prescription/i18n/lang.json": 4701,
	"rehabilitation/i18n/lang.json": 51894,
	"shared/i18n/lang.json": 12739,
	"specifics/i18n/lang.json": 11243,
	"stand-alone/i18n/lang.json": 31177,
	"stock/i18n/lang.json": 12132,
	"visit/i18n/lang.json": 87212,
	"workflow/i18n/lang.json": 2614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76800;